import { render, staticRenderFns } from "./HJ0135.vue?vue&type=template&id=1d954fc0&scoped=true&"
import script from "./HJ0135.vue?vue&type=script&lang=js&"
export * from "./HJ0135.vue?vue&type=script&lang=js&"
import style0 from "./HJ0135.vue?vue&type=style&index=0&id=1d954fc0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d954fc0",
  null
  
)

export default component.exports